import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { getTrainingData } from "../../services/Settings";
import { useToasts } from "react-toast-notifications";
import DataTable from "./DataTable";

export default function DataTagger() {
  const [data, setData] = useState(null);
  const [tagged, setTagged] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const { addToast } = useToasts();

  async function fetchData(tagged) {
    setFetchingData(true);
    setData(null);
    try {
      const result = await getTrainingData(tagged);
      if (result && result.Items && result.Items.length) {
        console.log("result", result);
        setData(result.Items);
      } else {
        addToast(
          `There is no ${
            tagged ? "tagged" : "untagged"
          } training data available`,
          {
            appearance: "info",
          }
        );
      }
      setFetchingData(false);
    } catch (err) {
      console.log("error", err);
      setFetchingData(false);
    }
  }
  if (data) {
    return (
      <Card>
        <Card.Title className="ml-2 mt-2 mb-2">
          {tagged ? "Tagged" : "Untagged"} training data list
        </Card.Title>
        <hr />
        <div>
          <Button
            variant="warning"
            className="ml-1 mb-2 mt-2"
            onClick={() => setData(null)}
          >
            Cancel
          </Button>
        </div>
        <DataTable data={data} />
        <div>
          <Button
            variant="warning"
            className="ml-1 mb-1 mt-1"
            onClick={() => setData(null)}
          >
            Cancel
          </Button>
        </div>
      </Card>
    );
  } else {
    return (
      <div className="card mb-4">
        <div className="card-body">
          <Button
            disabled={fetchingData}
            variant="primary"
            className="ml-1 mr-1 mb-1"
            onClick={() => {
              setTagged(false);
              fetchData(false);
            }}
          >
            Fetch untagged data
          </Button>
          <Button
            disabled={fetchingData}
            variant="primary"
            className="ml-1"
            onClick={() => {
              setTagged(true);
              fetchData(true);
            }}
          >
            Fetch tagged data
          </Button>
        </div>
      </div>
    );
  }
}
